<div class="modal-header">
  <h5 class="modal-title text-capitalize" id="myModalLabel">
    {{
    isEdit
    ? labelConstants.ViewUser
    : id === "0"
    ? labelConstants.AddUser
    : IsProfile
    ? labelConstants.MyProflle
    : labelConstants.EditUser
    }}
  </h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
    (click)="onClose('cancel')"></button>
</div>
<div class="modal-body">
  <form [formGroup]="addUserForm" (ngSubmit)="submitUserForm()" novalidate autocomplete="off">
    <!-- User Image -->
    <div class="row">
      <div class="form-group form-check p-0 mb-4">
        <label class="text-center mx-auto d-block">{{labelConstants.ProfilePicture}}</label>
        <div class="position-relative upload-btn mx-auto d-block text-center">
          <div>
            <img id="userLogoPreview" [src]="this.imageSrc" title="User Logo" class="mt-2" alt=""
              onerror="this.src='../../../assets/img/default-user-profile.svg'" />
            <a *ngIf="!isEdit" title="Remove Picture" class="file-input-thumbnail" data-dismiss="fileinput"
              href="javascript:void(0)" (click)="onFileChanged($event)"><i class="fa fa-times"></i></a>
          </div>
          <button *ngIf="!isEdit" type="button" class="upload-btn mt-2 ml-3" (click)="file.click()"
            title="Upload Logo">
            <img src="../../../../assets/img/img-icon.svg" alt="" />
          </button>
        </div>
        <input type="file" class="custom-file-input d-none" accept=".png, .jpg, .jpeg" id="uploaduserLogo"
          (change)="onFileChanged($event)" #file />
        <span id="userLogoName" class="text-center mx-auto d-block"></span>
      </div>
    </div>

    <!-- Firstname / Lastname -->
    <div class="row">
      <div class="col-sm-6 col-12">
        <div class="mb-3">
          <label class="form-label required">{{ labelConstants.FirstName
            }}<span class="text-danger" *ngIf="!isEdit">*</span>
          </label>
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <input formControlName="FirstName" class="form-control" autocomplete="nope"
              oninput="this.value = this.value.replace(/^\s+/g, '')" type="text" maxlength="49"
              placeholder="Enter first name" />
          </app-loader>
          <div class="text-danger" *ngIf="
              submitted && addUserForm.get('FirstName')?.hasError('required')
            ">
            {{ errorMessages.FirstNameRequired }}
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-12">
        <div class="mb-3">
          <label class="form-label required">{{ labelConstants.LastName
            }}<span class="text-danger" *ngIf="!isEdit">*</span>
          </label>
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <input class="form-control" formControlName="LastName"
              oninput="this.value = this.value.replace(/^\s+/g, '')" type="text" maxlength="49" autocomplete="nope"
              placeholder="Enter last name" />
          </app-loader>
          <div class="text-danger" *ngIf="
              submitted && addUserForm.get('LastName')?.hasError('required')
            ">
            {{ errorMessages.LastNameIsRequired }}
          </div>
        </div>
      </div>
    </div>

    <!-- Role -->
    <div class="row">
      <div class="col-md-6">
        <div class="mb-4">
          <label class="form-label required">{{ labelConstants.Role
            }}<span class="text-danger" *ngIf="!isEdit">*</span>
          </label>
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <ng-select [items]="roleList" bindLabel="roleName" bindValue="roleID" formControlName="Role"
              autocomplete="nope" placeholder="Select role" (change)="getCompanyListDropDown($event)">
            </ng-select>
          </app-loader>
          <div class="text-danger" *ngIf="submitted && addUserForm.get('Role')?.hasError('required')">
            {{ errorMessages.RoleNameRequired }}
          </div>
        </div>
      </div>
      <div *ngIf="isToShowCompany && roleId == 1" class="col-md-6">
        <div class="col-md-12">
          <div class="mb-4">
            <label class="form-label required">{{ labelConstants.Company
              }}<span class="text-danger" *ngIf="!isEdit">*</span>
            </label>
            <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
              <ng-select [items]="companyList" bindLabel="companyName" bindValue="id" formControlName="CompanyId"
                autocomplete="nope" placeholder="Select company.">
              </ng-select>
            </app-loader>
            <div class="text-danger" *ngIf="
                submitted &&
                addUserForm.get('CompanyId')?.hasError('required') &&
                isToShowCompany
              ">
              {{ errorMessages.CompanyRequired }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Email/PhoneNo -->
    <div class="row">
      <div class="col-sm-6 col-12">
        <div class="mb-3">
          <label class="form-label required">{{ labelConstants.Email
            }}<span class="text-danger" *ngIf="!isEdit">*</span>
          </label>
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <input class="form-control" formControlName="Email"
              oninput="this.value = this.value.trimStart().toLowerCase()" maxlength="99" autocomplete="nope"
              placeholder="Enter email" />
          </app-loader>
          <div class="text-danger" *ngIf="submitted && addUserForm.get('Email')?.hasError('required')">
            {{ errorMessages.EmalRequired }}
          </div>
          <div class="text-danger" *ngIf="submitted && GetUserFormControls['Email'].errors?.['pattern']">
            {{ errorMessages.EmailNotValid }}
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12">
        <div class="mb-3">
          <label class="form-label">{{ labelConstants.PhoneNumber
            }}<span class="text-danger" *ngIf="!isEdit">*</span></label>
          <app-loader [count]="1" [appearance]="'line'" [isLoading]="isLoading">
            <input class="form-control" formControlName="PhoneNumber" autocomplete="nope"
              oninput="this.value = this.value.replace(/[^\d+]/g, '').substring(0, 15)"
              placeholder="Enter phone number" />
          </app-loader>
          <div class="text-danger" *ngIf="
              submitted && addUserForm.get('PhoneNumber')?.hasError('required')
            ">
            {{ errorMessages.PhoneNoRequired }}
          </div>
          <div class="text-danger" *ngIf="submitted && GetUserFormControls['PhoneNumber'].errors?.['minlength']">
            {{ errorMessages.PhoneNumberNotValid }}
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary-datalist" data-bs-dismiss="modal" (click)="onClose('cancel')">
        CLOSE
      </button>
      <button type="submit" class="btn btn-primary-datalist" *ngIf="!isEdit"
        [disabled]="(!addUserForm.valid && submitted) || isLoading">
        {{ id === "0" ? commonConstants.Save : commonConstants.Update }}
      </button>
    </div>
    
  </form>
</div>